<div class="inputTitle" *ngIf="label">
    <span>{{ label }}
        <i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay" id="i1"
            class="flaticon-message" *ngIf="tooltipIcon"></i>
    </span>
</div>

<div [class.has-errors]="errors?.length" class="moneyForm" [hidden]="!isEditable">
    <div fxLayout="row" class="webMoney">
        <mat-form-field appearance="outline">
            <input matInput type="number" [name]="formFieldName" [ngModel]="amount" (ngModelChange)="setAmount($event)"
                [min]="minValue" [max]="maxValue" [disabled]="disabled">
        </mat-form-field>
        <div class="select" fxFlex="49px">
            <app-auto-search [isEditable]="true" [ngModel]="_currency" (ngModelChange)="setCurrency($event)"
                [listUrl]="currencyUrl" [trim]="true" [displayField]="'currency_code'" [disabled]="curdisabled"
                [idField]="'currency_code'">
            </app-auto-search>
        </div>
    </div>
</div>

<div class="viewLable" [hidden]="isEditable">
    <span>
        {{ getDisplay() }}
        <!-- {{amount}}
    {{currency}} -->
    </span>
</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{ item }}</li>
</ul>